/**
 * Hardware the platform speaks to, as it is sold.
 *
 * Shared between the admin's own registration form and the customer's claim
 * form so the two can never drift apart — the server maps each of these to a
 * wire protocol and refuses anything else.
 */
export const MODELS = [
  'GT06N',
  'GT06',
  'TR06',
  'GT02',
  'JM-VL01',
  'TK103',
  'TK103-2',
  'GPS103A',
  'GPS103B',
] as const;
